import { Container, Box } from "@mui/material";
import React from "react";
import GoBack from "../GoBack";
import GridLayout from "../GridLayout";
import Navbar from "../Navbar";
import PostEditor from "../PostEditor";
import Sidebar from "../Sidebar";

const CreatePostView = () => {
  return (
    <Box sx={{ backgroundColor: "#F5F5F5", minHeight: "100vh" }}>
      <Navbar />
      <Container maxWidth="lg" sx={{ py: 4 }}>
        <GoBack />
        <GridLayout left={<PostEditor />} right={<Sidebar />} />
      </Container>
    </Box>
  );
};

export default CreatePostView;
